import { render, staticRenderFns } from "./DoExamPaper.vue?vue&type=template&id=8087e690&scoped=true&"
import script from "./DoExamPaper.vue?vue&type=script&lang=js&"
export * from "./DoExamPaper.vue?vue&type=script&lang=js&"
import style0 from "./DoExamPaper.vue?vue&type=style&index=0&id=8087e690&scoped=true&lang=less&"
import style1 from "./DoExamPaper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8087e690",
  null
  
)

component.options.__file = "DoExamPaper.vue"
export default component.exports